class MainSlideshow extends HTMLElement {
  constructor() {
    super();
    this.swiperInit();
  }

  swiperInit() {
    this.slide_i = 0;
    this.timerSlide = document
      .querySelector('[data-slide="0"]')
      .getAttribute("data-duration");
    this.current_time = 0;
    this.progress_bar = document.querySelector(".progress-bar");
    this.numberSlide = document.querySelectorAll(
      ".main-slideshow__thumb li"
    ).length;

    this.swiper = new Swiper(".main-slideshow-left", {
      loopPreventsSlide: false,
      allowTouchMove: false,
      preloadImages: false,
      breakpoints: {
        990: {},
      },
    });

    this.swiper2 = new Swiper(".main-slideshow-right", {
      loopPreventsSlide: false,
      allowTouchMove: false,
      preloadImages: false,
      breakpoints: {
        990: {},
      },
    });

    this.swiperContent = new Swiper(".main-slideshow-content__swiper", {
      loopPreventsSlide: false,
      allowTouchMove: false,
      preloadImages: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        990: {},
      },
    });

    this.thumb = this.querySelectorAll("[data-slide]");
    this.thumb.forEach((button) =>
      button.addEventListener("click", this.slideIndex.bind(this))
    );

    this.startTimer();

    let first_color = document.querySelector(
      ".main-slideshow-left .swiper-slide:first-child"
    ).dataset.menu;

    if (first_color == "black") {
      document.querySelector("header").classList.add("invert");
    } else {
      document.querySelector("header").classList.remove("invert");
    }

    if (window.scrollY > 100) {
      document.querySelector("header").classList.add("invert");
    } else {
      if (first_color != "black")
        document.querySelector("header").classList.remove("invert");
    }

    this.swiper.on("slideChange", function (e) {
      let slide = e.slides[e.activeIndex];
      let color = slide.getAttribute("data-menu");

      if (color == "black") {
        document.querySelector("header").classList.add("invert");
      } else {
        document.querySelector("header").classList.remove("invert");
      }

      if (window.scrollY > 10) {
        document.querySelector("header").classList.remove("invert");
      }
    });
  }

  slideIndex(event) {
    var index = parseInt(event.target.getAttribute("data-slide"));
    this.current_time = 0;
    this.slide_i = parseInt(index);
    this.timerSlide = document
      .querySelector('[data-slide="' + this.slide_i + '"]')
      .getAttribute("data-duration");
    clearInterval(this.timerInterval);
    this.startTimer();
    this.slideAll(index);
    this.updateColors();
  }

  updateColors() {
    if (
      document.querySelector(
        ".swiper-slide-active.main-slideshow-right__content--black"
      )
    ) {
      document.querySelector(".main-slideshow__thumb").classList.add("black");
    } else {
      document
        .querySelector(".main-slideshow__thumb")
        .classList.remove("black");
    }
  }

  slideAll(index) {
    this.swiper.slideTo(index, 600, false);
    this.swiper2.slideTo(index, 600, false);
    this.swiperContent.slideTo(index, 600, false);
    this.updateColors();
  }

  fillProgressBar() {
    var bar_width = document.querySelector("[data-duration]").offsetWidth + 4;
    var duration = this.timerSlide * 1000;
    this.current_time = this.current_time + 50;
    if (this.current_time < duration) {
      this.progress_bar.style.width =
        "" +
        (this.slide_i * bar_width +
          bar_width * (this.current_time / duration)) +
        "px";
    } else {
      if (this.slide_i < this.numberSlide - 1) {
        this.current_time = 0;
        this.slide_i = this.slide_i + 1;
        this.timerSlide = document
          .querySelector('[data-slide="' + this.slide_i + '"]')
          .getAttribute("data-duration");
        clearInterval(this.timerInterval);
        this.slideAll(this.slide_i);
        this.startTimer();
      } else {
        this.current_time = 0;
        this.slide_i = 0;
        this.timerSlide = document
          .querySelector('[data-slide="0"]')
          .getAttribute("data-duration");
        clearInterval(this.timerInterval);
        this.slideAll(0);
        this.startTimer();
      }
    }
  }

  startTimer() {
    this.timerInterval = setInterval(this.fillProgressBar.bind(this), 50);
  }
}

customElements.define("main-slideshow", MainSlideshow);
